/*
 * @Author: jiangxd
 * @Date: 2021-08-04 11:24:01
 * @LastEditTime: 2021-08-04 11:41:28
 * @LastEditors: jiangxd
 * @Description:
 * @FilePath: /rs_ips_maintence/src/views/components/linkForm/WeChatMessage.tsx
 */
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import uuid4 from 'uuid';
import type { ElForm } from 'element-ui/types/form';
import DialogFactory from '../picker/dialogFactory';
// import style from "./style.vue";
import IPSDialog from '../picker/dialog';
import style from './style.vue';
@DialogFactory
@Component({
  mixins: [style],
})
export default class WeChatMessage extends IPSDialog {
  $refs: {
    form: ElForm;
  };

  linkArticleInfo: { articleTitle?: string; articleAddress?: string } = {
    articleTitle: '',
    articleAddress: '',
    // id:""
  };

  rules = {
    articleTitle: [{ required: true, message: '请输入公众号推文标题', trigger: 'blur' }],
    articleAddress: [{ required: true, message: '请输入公众号推文地址', trigger: 'blur' }],
  };

  title = '链接至公众号推文';

  width = '700px';

  confirmloading = false;

  articleId = uuid4();
  beforeConfirm(resp = {}, cb) {
    const name = this.linkArticleInfo.articleTitle;
    const url = this.linkArticleInfo.articleAddress;
    const id = this.articleId;
    this.$refs.form.validate((valid) => {
      if (valid) {
        this.$emit('result', { name, url, id });
        this.$emit('hidden');
      } else {
        this.confirmloading = false;
      }
    });
  }

  changeTitle(val) {
    this.$forceUpdate();
    if (val === '') {
      this.$message.error('请输入公众号推文标题');
    } else {
      this.linkArticleInfo.articleTitle = val;
    }
  }

  changeAddress(val) {
    this.$forceUpdate();
    if (val === '') {
      this.$message.error('请输入公众号推文地址');
    } else {
      this.linkArticleInfo.articleAddress = val;
    }
  }

  renderContent(h) {
    return (
      <div class="wechatAccount">
        <el-form props={{ model: this.linkArticleInfo }} rules={this.rules} ref="form" label-position="top">
          <el-form-item label="公众号推文标题" prop="articleTitle">
            <el-input v-model={this.linkArticleInfo.articleTitle}></el-input>
          </el-form-item>
          <el-form-item label="公众号推文地址" prop="articleAddress">
            <el-input v-model={this.linkArticleInfo.articleAddress}></el-input>
            <p class="tip">
              <span class="redText">*&nbsp;</span>仅支持链接至与当前小程序关联的公众号中的推文。
            </p>
          </el-form-item>
        </el-form>
      </div>
    );
  }
}
